import { useTranslation } from "react-i18next";
import _ from "lodash";
import { useLocation, useNavigate } from "react-router-dom";
import "./style.css"
import classNames from "classnames";
import { useState } from "react";

const CopyComponent = (props: {id: string, content: string, className: string, classIcon?: string}): JSX.Element => {
    const { id, content, className, classIcon } = props;
    const [copy, setIsCopy] = useState(false);

    const copyToClipboard = (value: string) => {
      // Create a "hidden" input
      let aux = document.createElement("input");

      // Assign it the value of the specified element
      aux.setAttribute("value", value);

      // Append it to the body
      document.body.appendChild(aux);

      // Highlight its content
      aux.select();

      // Copy the highlighted text
      document.execCommand("copy");

      // Remove it from the body
      document.body.removeChild(aux);
    }

    return (
        <span className={classNames("copy-button", className)}
            id={id}
            onClick={() => {
                copyToClipboard(content)
                if(copy === false) {
                    setIsCopy(true)
                    setTimeout(function () {
                            setIsCopy(false)
                    }, 2000);
                }
            }}
        ><i className={classNames("fa-light", classIcon, { "fa-circle-check text-green-500": copy }, { "fa-copy dark:text-white cursor-pointer": !copy })} />
        </span>
    )
}

export default function ImageTransaction() {
  const { t } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()

  return (
    <div x-show="modalOpen" x-transition="" className="fixed top-0 left-0 z-999 flex h-full min-h-screen w-full items-center justify-center bg-black/90">
      <div className="w-full max-w-screen-lg rounded-lg bg-white py-5 px-8 dark:bg-boxdark relative">
        <h3 className="text-xl dark:text-white text-center font-medium my-5 mt-1 mb-8">
          {t("transaction.link_images")}
        </h3>
        <div className="absolute top-2 right-5 p-2 cursor-pointer" onClick={() => navigate(location, {state: {reload: false}})}>
          <i className="fa-regular fa-xmark fa-lg text-gray-500 fa-xl dark:text-white" />
        </div>
        <div className="h-full">
          {/* <iframe src={location.state?.images[0]} className="w-full h-full overflow-auto" title="Transaction Image"></iframe> */}
          <div className="text-center mb-8 flex flex-col items-center gap-2">
            {location.state?.images.map((image: string, index: number) => (
              <p className="flex" key={index}>
                <a key={index} href={image} target="_blank" rel="noopener noreferrer" className="block dark:text-white whitespace-nowrap text-ellipsis max-w-96 overflow-hidden inline-block">{image}</a>
                <CopyComponent
                  className="react-select-copy ms-2"
                  id={"tooltipCopy-" + index}
                  content={image}
                  classIcon="fa-md"
                />
              </p>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
